import favicon from 'assets/icons/pic2.png'

export const Logo = () => {
	return (
		<img style={{ height: '100%' }} src={favicon} />
	);
};
